var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import MessageDialog from './MessageDialog.vue';
import { PinCodeHelper, WalletsHelper } from "../../lib/storage";
import MessageModule from "../mixins/MessageModule";
const inputSize = 48;
const inputHorizontalMargin = 8;
const inputVerticalMargin = 4;
export default Vue.extend({
    mixins: [MessageModule],
    components: {
        MessageDialog,
    },
    name: "PinInput",
    props: {
        // "check" or "register"
        mode: {
            type: String,
            default: "check",
        },
        value: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            input: "",
            styles: {
                container: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    width: ((inputSize + inputHorizontalMargin * 2) * 3).toString() + "px"
                },
                inputCard: {
                    marginTop: inputVerticalMargin.toString() + "px",
                    marginBottom: inputVerticalMargin.toString() + "px",
                    marginLeft: inputHorizontalMargin.toString() + "px",
                    marginRight: inputHorizontalMargin.toString() + "px",
                },
                input: {
                    width: inputSize.toString() + "px",
                    height: inputSize.toString() + "px",
                    borderRadius: "10px",
                    border: "2px solid white",
                    position: "relative",
                }
            },
            registeredPin: '',
            oldPin: '',
            states: {
                check: 1,
                registration: 2,
                confirmation: 3,
            },
            state: 0,
            showRegistration: this.isRegisterMode() && this.value,
            showSuccess: false,
        };
    },
    methods: {
        onClickedCode(code) {
            return __awaiter(this, void 0, void 0, function* () {
                this.input = this.input + code.toString();
                if (this.input.length >= 6) {
                    if (this.isCheckMode()) {
                        // check with current encrypted account
                        if (yield PinCodeHelper.check(this.input)) {
                            yield this.closeView();
                        }
                        else {
                            this.retry();
                        }
                    }
                    else if (this.isRegisterMode()) {
                        if (this.state === this.states.registration) {
                            this.registeredPin = this.input;
                            this.input = '';
                            this.state = this.states.confirmation;
                        }
                        else {
                            if (this.registeredPin === this.input) {
                                this.showSuccess = true;
                                yield WalletsHelper.encryptWallets(PinCodeHelper.defaultPin, this.input);
                                yield PinCodeHelper.update(this.input);
                            }
                            else {
                                this.retry();
                            }
                        }
                    }
                    else if (this.isChangeMode()) {
                        // check with current encrypted account
                        if (this.state === this.states.check) {
                            if (yield PinCodeHelper.check(this.input)) {
                                this.oldPin = this.input;
                                this.input = '';
                                this.state = this.states.registration;
                            }
                            else {
                                this.retry();
                            }
                        }
                        else if (this.state === this.states.registration) {
                            this.registeredPin = this.input;
                            this.input = '';
                            this.state = this.states.confirmation;
                        }
                        else {
                            if (this.registeredPin === this.input) {
                                const oldPin = (yield PinCodeHelper.hasSavedCode()) ? this.oldPin : PinCodeHelper.defaultPin;
                                if (yield WalletsHelper.encryptWallets(oldPin, this.input)) {
                                    yield PinCodeHelper.update(this.input);
                                    this.showSuccess = true;
                                }
                                else {
                                    this.showError('Failed to change pin!');
                                    yield this.cancel();
                                }
                            }
                            else {
                                this.retry();
                            }
                        }
                    }
                }
            });
        },
        closeView() {
            return __awaiter(this, void 0, void 0, function* () {
                this.$emit('input', false);
                this.$emit('pass', this.input);
                yield this.initializeState();
            });
        },
        cancel() {
            return __awaiter(this, void 0, void 0, function* () {
                this.input = '';
                this.$emit('input', false);
                this.$emit('cancel');
                yield this.initializeState();
            });
        },
        isCheckMode() {
            return this.mode === 'check';
        },
        isRegisterMode() {
            return this.mode === 'register';
        },
        isChangeMode() {
            return this.mode === 'change';
        },
        retry() {
            this.showError(this.$t('common.pin_retry').toString());
            this.input = "";
        },
        initializeState() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isCheckMode()) {
                    this.state = this.states.check;
                }
                else if (this.isRegisterMode()) {
                    this.state = this.states.registration;
                }
                else if (this.isChangeMode()) {
                    if (yield PinCodeHelper.hasSavedCode()) {
                        this.state = this.states.check;
                    }
                    else {
                        this.state = this.states.registration;
                    }
                }
                this.oldPin = '';
                this.registeredPin = '';
                this.input = '';
            });
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initializeState();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/PinDialog.vue
// module id = 610
// module chunks = 1